import script from "./MenuInfoBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuInfoBar.vue?vue&type=script&setup=true&lang=ts"

import "./MenuInfoBar.vue?vue&type=style&index=0&id=2218558b&lang=scss"

const __exports__ = script;

export default __exports__